import React, { forwardRef } from 'react';

/**
 * Instagram/Facebook-portrait shareable card (1080x1350 @ scale 1).
 * Rendered off-screen; captured to PNG via html-to-image.
 */
const ShareableCareCard = forwardRef(({ primary, secondary, giving }, ref) => {
  const p = primary?.[0];
  const s = secondary?.[0];
  const g = giving?.[0];
  if (!p) return null;

  return (
    <div
      ref={ref}
      data-testid="shareable-care-card"
      style={{
        width: 1080,
        height: 1350,
        padding: 72,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        background:
          'linear-gradient(135deg, #0e7490 0%, #0891b2 45%, #14b8a6 100%)',
        color: 'white',
        fontFamily: 'Outfit, Inter, sans-serif',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {/* Decorative rings */}
      <div style={{
        position: 'absolute', right: -180, top: -180, width: 520, height: 520,
        borderRadius: '50%', background: 'rgba(255,255,255,0.06)',
      }} />
      <div style={{
        position: 'absolute', left: -140, bottom: -140, width: 400, height: 400,
        borderRadius: '50%', background: 'rgba(255,255,255,0.05)',
      }} />

      {/* Top: brand */}
      <div style={{ position: 'relative', zIndex: 1 }}>
        <div style={{
          display: 'inline-block', padding: '10px 22px', borderRadius: 999,
          background: 'rgba(255,255,255,0.15)', backdropFilter: 'blur(10px)',
          fontSize: 22, fontWeight: 600, letterSpacing: 2, textTransform: 'uppercase',
        }}>
          CircleUpSquad
        </div>
        <p style={{
          marginTop: 40, fontSize: 30, letterSpacing: 4, opacity: 0.85,
          textTransform: 'uppercase', fontWeight: 600,
        }}>
          My Care Profile™
        </p>
      </div>

      {/* Middle: name + description */}
      <div style={{ position: 'relative', zIndex: 1 }}>
        <h1 style={{
          fontSize: p.name.length > 22 ? 88 : 108,
          fontWeight: 800, lineHeight: 1.05, letterSpacing: -1,
          margin: 0, textShadow: '0 4px 24px rgba(0,0,0,0.15)',
        }}>
          {p.name}
        </h1>
        <p style={{
          marginTop: 28, fontSize: 34, lineHeight: 1.4, opacity: 0.95,
          maxWidth: 900, fontWeight: 400,
        }}>
          {p.description}
        </p>

        {(s || g) && (
          <div style={{
            marginTop: 44, paddingTop: 32,
            borderTop: '1px solid rgba(255,255,255,0.25)',
            display: 'flex', gap: 60, flexWrap: 'wrap',
          }}>
            {s && (
              <div>
                <p style={{ fontSize: 18, letterSpacing: 2, opacity: 0.7, textTransform: 'uppercase', margin: 0 }}>Secondary</p>
                <p style={{ fontSize: 32, fontWeight: 700, margin: '6px 0 0' }}>{s.name}</p>
              </div>
            )}
            {g && (
              <div>
                <p style={{ fontSize: 18, letterSpacing: 2, opacity: 0.7, textTransform: 'uppercase', margin: 0 }}>Caregiver Style</p>
                <p style={{ fontSize: 32, fontWeight: 700, margin: '6px 0 0' }}>{g.name}</p>
              </div>
            )}
          </div>
        )}
      </div>

      {/* Bottom: CTA */}
      <div style={{ position: 'relative', zIndex: 1 }}>
        <div style={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        }}>
          <div>
            <p style={{ fontSize: 22, opacity: 0.75, margin: 0, letterSpacing: 1 }}>Discover yours</p>
            <p style={{ fontSize: 36, fontWeight: 700, margin: '4px 0 0' }}>circleupsquad.com</p>
          </div>
          <div style={{
            padding: '18px 34px', borderRadius: 999,
            background: 'white', color: '#0e7490',
            fontSize: 24, fontWeight: 700, letterSpacing: 1,
          }}>
            Take the Quiz →
          </div>
        </div>
        <p
          data-testid="share-card-watermark"
          style={{
            margin: '30px 0 0', fontSize: 20, letterSpacing: 1.5,
            opacity: 0.6, fontWeight: 500,
          }}
        >
          circleupsquad.com/care-profile-quiz
        </p>
      </div>
    </div>
  );
});

ShareableCareCard.displayName = 'ShareableCareCard';
export default ShareableCareCard;
